import ClassActivity from './template';
export default ClassActivity;
